import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getProductNameTextFromApiName } from 'ui-addon-upgrades/_core/common/adapters/getProductNameText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubProductHeader = ({
  apiName,
  showIcon = true
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "align-center m-bottom-2",
    children: [showIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "upgrade",
      size: 20,
      className: "m-right-2",
      color: LORAX
    }), /*#__PURE__*/_jsx("p", {
      className: "m-bottom-0",
      children: isValidI18nKey(`upgrades.products.${apiName}`) ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.upgradeToProduct",
        options: {
          productTitle: getProductNameTextFromApiName(apiName)
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.upgradeToGeneralProduct"
      })
    })]
  });
};